import './creationWebapp.scss';
import React, { useEffect, useState, useContext} from 'react';
import SelectPays, {PAYS} from '../../Composants/selectPays/selectPays';
import { baseSelectionneeContext } from '../../../App';
import AppelerApi from '../../../services/appeler-api.service';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormLabel, 
    RadioGroup, 
    Radio, 
    FormControlLabel,
    Checkbox,
    Tooltip
} from '@mui/material';
import ValideIcone from '@mui/icons-material/Check';
import InvalideIcone from '@mui/icons-material/Block';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';


const CreationWebapp = () => {

    const { baseSelectionnee} = useContext(baseSelectionneeContext);
    
    const formDataInitiale = {
        numeroFiche: "",
        raison: "",
        nom: "",
        adresse: "",
        codePostal: "",
        ville: "",
        telephone: "",
        email: "",
        login: "",
        pays: "1",
        optionsMarques: "LSC",
        choixModele: "SPECIAL::LSC",
        typeSalon: "coiffure",
        tva: "20",
        choixCreationParDefaut: "0",
        creationSiteReservation: "1",
        urlReservation: "",
        nePasEnvoyerGOMC: "1",
    };
    const [formData, setFormData] = useState(formDataInitiale);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [raisonSocialeFIC, setRaisonSocialeFIC] = useState('');
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isClicked, setIsClicked] = useState(false);
    const [optionsModeles, setOptionsModeles] = useState([
        { value: 'defaut', libelle: 'Par défaut de la marque' }
    ]);
    const [urlReservation, setUrlReservation] = useState('');
    const [urlReservationInvalide, setUrlReservationInvalide] = useState(true);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const chercherIdPaysAvecCode = (codePays) => {
        const country = PAYS.find(pays => pays.code === codePays);
        return country ? country.id : null;
    };

    const chercherInfosFicClient = async (numeroFiche) => {
        try {
            const donnees = {
                numeroFiche: parseInt(numeroFiche),
                baseSelectionnee: baseSelectionnee
            }
            const reponse = await AppelerApi.post('/rechercher-infos-fiche-client', donnees);
            if (reponse.raisonSociale != null) {
                setRaisonSocialeFIC(reponse.raisonSociale);
                const idPays = reponse.codePays ? chercherIdPaysAvecCode(reponse.codePays) : "1";
                setFormData(formData => ({ 
                    ...formData,
                    adresse: reponse.adresse,
                    email: reponse.emailSalon,
                    codePostal: reponse.codePostal,
                    ville: reponse.ville,
                    pays: idPays || formData.pays,
                    telephone: reponse.numTel,
                    raison: reponse.raisonSociale
                }));
            } else {
                setRaisonSocialeFIC('');
                setFormData(formData => ({
                    ...formDataInitiale,
                    numeroFiche: formData.numeroFiche
                }));
            }
        } catch (error) {
            console.error('Erreur lors de la requête:', error);
        }
    };

    const handleNumberInput = (e) => {
        const { name, value } = e.target;
        if (value === '' || /^[0-9]+$/.test(value)) {
            setFormData( formData => ({ ...formData, [name]: value }));
        }

        if (name === 'numeroFiche') {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
            setTypingTimeout(setTimeout(() => {
                if(value !== '') {
                    chercherInfosFicClient(value);
                } else {
                    setRaisonSocialeFIC('');
                }
                
            }, 1000));
        }
    };

    const mettreAJourUrlReservation = () => {
        if ((!formData.nom || formData.nom === '') && (!formData.raison || formData.raison === '')) {
            return;
        }
        const proposition = ((formData.nom && formData.nom !== '') ? formData.nom : formData.raison) + (formData.codePostal && formData.codePostal !== '' ? '-' + formData.codePostal : '');
        modifierUrlReservation(proposition);
    };

    useEffect(() => {
        mettreAJourUrlReservation();
    }, [formData.nom, formData.raison, formData.codePostal]);

    const modifierUrlReservation = (e) => {
        let url = e.target ? e.target.value : e;
        url = url.trim().replace(/\s+/g, '-').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''); // remplace les caractères avec accents et diacritiques
        setUrlReservation(url);
        verifierUrlReservation(url);
    };
    
    const verifierUrlReservation = useCallback(debounce((url) => {
        AppelerApi.get('/lire-site-reservation-existe', { urlReservation: url }).then(reponse => {
            setUrlReservationInvalide(reponse.existe);
        });
    }, 500), []);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        //incomplete cond
        if (
            (baseSelectionnee === 'PROD' && (
            !formData.numeroFiche ||
            !formData.raison ||
            !formData.nom ||
            !formData.pays ||
            !formData.ville ||
            !formData.codePostal ||
            !formData.adresse ||
            !formData.telephone ||
            !formData.email ||
            !formData.login ||
            !formData.choixModele ||
            !formData.optionsMarques ||
            !formData.typeSalon ||
            !formData.tva ||
            !formData.choixCreationParDefaut ||
            !formData.creationSiteReservation))
            || 
            (baseSelectionnee === 'DEV' && (
            !formData.raison ||
            !formData.nom ||
            !formData.pays ||
            !formData.ville ||
            !formData.codePostal ||
            !formData.adresse ||
            !formData.telephone ||
            !formData.email ||
            !formData.login ||
            !formData.choixModele ||
            !formData.optionsMarques ||
            !formData.typeSalon ||
            !formData.tva ||
            !formData.choixCreationParDefaut ||
            !formData.creationSiteReservation))
        ) {
            alert("Veuillez renseigner tous les champs.");
            return;
        }

        if (formData.creationSiteReservation === '1' && urlReservation === '') {
            alert('Il vous faut une URL pour le site de réservation si vous désirez le créer');
            return;
        }

        if (formData.creationSiteReservation === '1' && urlReservationInvalide) {
            alert('L\'URL que vous avez choisie est déjà utilisée, veuillez en choisir une autre');
            return;
        }

        //erreur modele
        if (formData.choixModele === 'defaut') {
            alert("Modèle non valable.");
            return;
        }

        //prod numfic cond
        if (baseSelectionnee === 'PROD' && (raisonSocialeFIC === ''  || raisonSocialeFIC == null)) {
            alert("Le numéro de fiche client n'existe pas, veuillez vérifier le numéro de fiche.");
            return;
        }

        //test numfic cond
        if (baseSelectionnee === 'DEV' && (!formData.numeroFiche || formData.numeroFiche === '')) {
            AppelerApi.get('/chercher-num-fic-client-vide').then(data => {
                setFormData({ ...formData, numeroFiche: data.numFicClient.toString() });
            });
        }

        formData.urlReservation = urlReservation;

        // trim
        const sanitizedData = { ...formData };
        Object.keys(sanitizedData).forEach((key) => {
            if (typeof sanitizedData[key] === 'string') {
                sanitizedData[key] = sanitizedData[key].trim();
            }
        });
        setFormData(sanitizedData);

        //validators
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+$/;
        if (!emailRegex.test(formData.email)) {
            alert("Veuillez saisir une adresse email valide");
            return;
        }
        setDialogOpen(true);
    };

    const handleClose = () => {
        setErrorMessage('');
        setDialogOpen(false);
    };

    const handleContinue = async () => {
        setIsClicked(true);
        const paysChoisi = PAYS.find(pays => pays.id === formData.pays);
        // api call
        try {
            const dataBDD = {
                ...formData,
                paysNom: paysChoisi.name,
                paysID: paysChoisi.id,
                paysCode: paysChoisi.code,
                paysPhoneCode: paysChoisi.phoneCode,
                baseSelectionnee: baseSelectionnee
            };
            const reponse = await AppelerApi.post('/creer-webapp', dataBDD);
            if (reponse.message === 'Succès' && !reponse.codeHttp) {
                setErrorMessage('');
                setDialogOpen(false);
                setSuccessDialogOpen(true);
            } else {
                if (reponse.error === 'Aucun compte vide trouvé') {
                    setErrorMessage('Aucun compte SMS vide trouvé, veuillez contacter l\'équipe de Nicolas');
                } else {
                    let errorMessage = reponse.error + reponse.details;
                    setErrorMessage(errorMessage);
                }
            }
        } catch (error) {
            console.error('Erreur lors de la requête de connexion:', error);
        } finally {
            setTimeout(() => {
                setIsClicked(false);
            }, 500);
        }
    }

    const handleCloseSuccessDialog = () => {
        setSuccessDialogOpen(false);
    };

    const lireFicClient = () => {
        if (localStorage.getItem('idFicClient-pour-creation-webapp')) {
            const idFicClient = localStorage.getItem('idFicClient-pour-creation-webapp');
            localStorage.removeItem('idFicClient-pour-creation-webapp');
            const nouveauParametre = { numeroFiche: idFicClient };
            setFormData({ ...formData, ...nouveauParametre });
            handleNumberInput({ target: { name: 'numeroFiche', value: idFicClient }});
        }
    };

    useEffect(() => {
        if (formData.optionsMarques === 'LSC') {
            setFormData(form => ({ ...form, typeSalon: 'coiffure' }));
        } else if (formData.optionsMarques === 'LSI') {
            setFormData(form => ({ ...form, typeSalon: 'institut' }));
        } else if (formData.optionsMarques === 'H+') {
            setFormData(form => ({ ...form, typeSalon: 'coiffure' }));
        }
    }, [formData.optionsMarques]);

    useEffect(() => {
        const chercherModeles = async () => {
            try {
                const reponse = await AppelerApi.get('/chercher-modeles');
                if (reponse && reponse.modeles) {
                    const options = [
                            ...reponse.modeles.map(modele => ({
                            value: modele.valeurModele,
                            libelle: modele.modele,
                        }))
                    ];
                    setOptionsModeles(options);

                    setFormData(formData => ({
                        ...formData,
                        choixModele: options[0].value
                    }));
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des modèles:', error);
            }
        };
        
        chercherModeles();
        lireFicClient();
    }, []);

    useEffect(() => {
        setFormData(form => ({ 
            ...form, 
            choixCreationParDefaut: form.optionsMarques === 'LSI' ? "0" : "1" 
        }));
    }, [formData.optionsMarques]);

    return (
        <div className="conteneur-creationWebapp">
            <h2>Création de webapp</h2>
            <div className="bloc-fonctionnel-creation-webapp">
                <form>
                    <div className="form-grid">
                        <TextField
                            label="Numéro fiche client"
                            name="numeroFiche"
                            value={formData.numeroFiche || ''}
                            onChange={handleNumberInput}
                            inputProps={{ 
                                pattern: '[0-9]*',
                                inputMode: 'numeric'
                            }}
                            fullWidth
                        />

                        <TextField
                            label="Raison sociale associée à la fiche"
                            name="RaisonSocFiche"
                            value={raisonSocialeFIC || ''}
                            disabled
                            fullWidth
                        />

                        <TextField
                            label="Nom commercial du salon"
                            name="nom"
                            value={formData.nom}
                            onChange={handleChange}
                            fullWidth
                        />

                        <TextField
                            label="Raison sociale du salon"
                            name="raison"
                            value={formData.raison}
                            onChange={handleChange}
                            fullWidth
                        />

                        <SelectPays
                            value={formData.pays || "1"}
                            onChange={handleChange}
                            style={{ marginBottom: "1rem" }}
                            defaultValue="1"
                        />

                        <TextField
                            label="Ville"
                            name="ville"
                            value={formData.ville}
                            onChange={handleChange}
                            fullWidth
                        />

                        <TextField
                            label="Code postal"
                            type="tel"
                            name="codePostal"
                            value={formData.codePostal}
                            onChange={handleNumberInput}
                            inputProps={{ 
                                pattern: '[0-9]*',
                                inputMode: 'numeric'
                            }}
                            fullWidth
                        />
                        
                        <TextField
                            label="Adresse"
                            name="adresse"
                            value={formData.adresse}
                            onChange={handleChange}
                            fullWidth
                        />
                        
                        <TextField
                            label="Téléphone"
                            type="tel"
                            name="telephone"
                            value={formData.telephone}
                            onChange={handleNumberInput}
                            inputProps={{ 
                                pattern: '[0-9]*',
                                inputMode: 'numeric'
                            }}
                            fullWidth
                        />
                        <TextField
                            label="E-mail"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            fullWidth
                        />
                    </div>

                    <TextField
                        className="form-full-width"
                        label="Login"
                        name="login"
                        value={formData.login}
                        onChange={handleChange}
                        inputProps={{ maxLength: 30 }}
                        fullWidth
                        error={Boolean(formData.login && !/^[a-zA-Z0-9]{1,30}$/.test(formData.login))}
                        helperText={
                            formData.login && !/^[a-zA-Z0-9]{1,30}$/.test(formData.login)
                                ? "Le login doit contenir uniquement des lettres et des chiffres (30 caractères maximum)"
                                : "Maximum 30 caractères, lettres et chiffres uniquement"
                        }
                    />

                    <FormControl fullWidth style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <InputLabel id="labeleModele">Choix du modèle</InputLabel>
                        <Select
                            labelId="labeleModele"
                            label="Choix du modèle"
                            name="choixModele"
                            value={formData.choixModele}
                            onChange={handleChange}
                        >
                            {optionsModeles.map((option) => (
                                <MenuItem 
                                    key={option.value} 
                                    value={option.value} 
                                >
                                    {option.libelle}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <div className="form-section">
                        <FormLabel component="legend">Marque</FormLabel>
                        <RadioGroup
                            row
                            name="optionsMarques"
                            value={formData.optionsMarques || "LSC"}
                            onChange={handleChange}
                            style={{ justifyContent: 'center' }}
                        >
                            <FormControlLabel value="LSC" control={<Radio />} label="LS Coiffure" />
                            <FormControlLabel value="LSI" control={<Radio />} label="LS Institut" />
                            <FormControlLabel value="H+" control={<Radio />} label="Hairnet+" />
                        </RadioGroup>
                    </div>

                    <div className="form-section">
                        <fieldset 
                            disabled={formData.optionsMarques !== 'H+'} 
                            style={{ 
                                border: 'none', 
                                padding: 0, 
                                opacity: formData.optionsMarques !== 'H+' ? 0.5 : 1,
                                pointerEvents: formData.optionsMarques !== 'H+' ? 'none' : 'auto'
                            }}
                        >
                            <FormLabel component="legend">Type de salon</FormLabel>
                            <RadioGroup
                                row
                                name="typeSalon"
                                value={formData.typeSalon || "coiffure"}
                                onChange={handleChange}
                                style={{ justifyContent: 'center' }}
                            >
                                <FormControlLabel value="coiffure" control={<Radio />} label="Coiffure" />
                                <FormControlLabel value="institut" control={<Radio />} label="Institut" />
                            </RadioGroup>
                        </fieldset>
                    </div>

                    <div className="form-section">
                        <FormLabel component="legend">TVA</FormLabel>
                        <RadioGroup
                            row
                            name="tva"
                            value={formData.tva || "0"}
                            onChange={handleChange}
                            style={{ justifyContent: 'center' }}
                        >
                            <FormControlLabel value="0" control={<Radio />} label="0%" />
                            <FormControlLabel value="8.1" control={<Radio />} label="8.1% (Suisse)" />
                            <FormControlLabel value="8.5" control={<Radio />} label="8.5% (Guadeloupe, Martinique, Réunion)" />
                            <FormControlLabel value="20" control={<Radio />} label="20% (France)" />
                            <FormControlLabel value="21" control={<Radio />} label="21% (Belgique)" />
                        </RadioGroup>
                    </div>

                    <div className="ligne-champs">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formData.choixCreationParDefaut === "1"}
                                    onChange={e =>
                                        setFormData(form => ({
                                            ...form,
                                            choixCreationParDefaut: e.target.checked ? "1" : "0"
                                        }))
                                    }
                                    name="choixCreationParDefaut"
                                    color="primary"
                                />
                            }
                            label="Créer les services, forfaits et familles par défaut."
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formData.creationSiteReservation === "1"}
                                    onChange={e =>
                                        setFormData(form => ({
                                            ...form,
                                            creationSiteReservation: e.target.checked ? "1" : "0"
                                        }))
                                    }
                                    name="creationSiteReservation"
                                    color="primary"
                                />
                            }
                            label="Créer le site de réservation"
                        />
                        <TextField
                            label="Url du site"
                            type="tel"
                            name="urlReservation"
                            value={urlReservation}
                            onChange={modifierUrlReservation}
                        />
                        {(!urlReservationInvalide &&
                            <ValideIcone className="valide"/>
                        )}
                        {(urlReservationInvalide &&
                            <Tooltip title="Ce site existe déjà">
                                <InvalideIcone className="invalide"/>
                            </Tooltip>
                        )}
                    </div>

                    <div className="ligne-champs">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formData.nePasEnvoyerGOMC === "1"}
                                    onChange={e =>
                                        setFormData(form => ({
                                            ...form,
                                            nePasEnvoyerGOMC: e.target.checked ? "1" : "0"
                                        }))
                                    }
                                    name="nePasEnvoyerGOMC"
                                    color="primary"
                                />
                            }
                            label="Ne pas envoyer à GOMC"
                        />
                    </div>
                    
                    <div className="form-actions">
                        <Button variant="contained"
                        type="submit" 
                        onClick={handleSubmit}>
                            Valider
                        </Button>
                    </div>
                </form>
            </div>
            
            <Dialog open={dialogOpen} onClose={handleClose}>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Vous allez créer une webapp dans la base de {baseSelectionnee === 'DEV' ? 'Test': 'Production'}
                    </DialogContentText>
                    {errorMessage && (
                        <DialogContentText style={{ color: 'red', marginTop: '1rem' }}>
                            {errorMessage}
                        </DialogContentText>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Annuler
                    </Button>
                    <Button 
                        onClick={handleContinue} 
                        color="primary"
                        disabled={isClicked}>
                        Continuer
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={successDialogOpen} onClose={handleCloseSuccessDialog}>
                <DialogTitle>Création de webapp pour {formData.login}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Activation de la régie SMS
                    </DialogContentText>
                    <DialogContentText>
                        100 SMS credités
                    </DialogContentText>
                    <DialogContentText>
                        Création de la webapp réussie
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseSuccessDialog} autoFocus>
                        Fermer
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CreationWebapp;